import { Component } from "@angular/core";
import { ActivatedRoute} from "@angular/router";
import { UrlQueryDef } from "../../../../_appCommon/base/UrlQueryDef";
import { FileAdditionalArray, FileType } from "../../../../_appCommon/base/AppInterfaceAndBaseClasses";
import { MediaDataService } from "../../../../_dataservices/MediaDataService";
import { FormGroup, FormBuilder} from '@angular/forms';
import { CaseAdditionalFilesDataService } from "../../../../_dataservices/CaseAdditionalFilesDataService";
import { ControllerBase } from "../../../../_appCommon/base/ControllerBase";
import { AppClientContext } from "../../../../_appCommon/base/AppClientContext";


@Component({
  selector: 'app-client-case-additional-files',
  templateUrl: './case-additional-file.component.html',
  styleUrls: ['./case-additional-file.component.css'],
  providers: [MediaDataService, CaseAdditionalFilesDataService]
})
export class CaseAdditionalFilesComponent extends ControllerBase
{
  //Additional files form
  public additionalFilesForm: FormGroup;
  //Additional files array
  public fileAdditionalArray: any[];
  //Additional files response
  private additionalFilesResponse: any[];

  constructor(protected route: ActivatedRoute,
    protected caseAdditionalDataService: CaseAdditionalFilesDataService,
    private mediaDataService: MediaDataService,
    private formBuilder: FormBuilder)
  {
    super();
  }

  ngOnInit(): void
  {
    this.initializeForms();
    this.initializeArrays();
    this.getAllCaseAdditionalFiles();
  }
  /**
   * Method used to initialize a form. This form has 10 additional dynamic files
   * */
  private initializeForms(): void
  {
    this.additionalFilesForm = this.formBuilder.group({
      AdditionalFile0: [null, ''],
      AdditionalFile1: [null, ''],
      AdditionalFile2: [null, ''],
      AdditionalFile3: [null, ''],
      AdditionalFile4: [null, ''],
      AdditionalFile5: [null, ''],
      AdditionalFile6: [null, ''],
      AdditionalFile7: [null, ''],
      AdditionalFile8: [null, ''],
      AdditionalFile9: [null, ''],
      AdditionalFile10: [null, ''],
    });
  }
  /**
   * Method used to initialize an array of additional files
   * */
  private initializeArrays(): void
  {
    this.fileAdditionalArray = [JSON.parse(JSON.stringify(FileAdditionalArray))];
  }
  /**
   * Method used to retrieve all of the additional files if exists
   * */
  private getAllCaseAdditionalFiles(): void
  {
    this.caseAdditionalDataService.getCaseAdditional(this.onGetQueryDefForCaseAdditional(this.GetCaseId))
      .subscribe((response: any) =>
      {
        this.additionalFilesResponse = response;
        this.setCaseAdditionalFiles();
      });
  }
  /**
   * Method used to create a queryDef to retrieve all of the additional files if exists
   * */
  public onGetQueryDefForCaseAdditional(CaseId: any): UrlQueryDef
  {
    let queryDef = new UrlQueryDef();
    queryDef.addParam("caseId", CaseId);
    return queryDef;
  }
  /**
   * Method used to set all of the additional files if exists
   */
  private setCaseAdditionalFiles(): void
  {
    for (let i = 0; i < this.additionalFilesResponse.length; i++)
    {
      if (i == 0)
      {
        this.fileAdditionalArray[i].Id = 0;
        this.fileAdditionalArray[i].label = this.additionalFilesResponse[i].name.slice(this.additionalFilesResponse[i].name.indexOf("_") + 1, this.additionalFilesResponse[i].name.length);
        this.fileAdditionalArray[i].name = "AdditionalFile" + i.toString();
        this.fileAdditionalArray[i].fileInfo = { name: this.additionalFilesResponse[i].name, url: this.additionalFilesResponse[i].path, blobId: this.additionalFilesResponse[i].blobId };
      }
      else
      {
        this.fileAdditionalArray.push(
          {
            Id: i,
            type: FileType.AdditionalCaseFileId,
            label: this.additionalFilesResponse[i].name.slice(this.additionalFilesResponse[i].name.indexOf("_") + 1, this.additionalFilesResponse[i].name.length),
            name: "AdditionalFile" + i.toString(),
            fileInfo: { name: this.additionalFilesResponse[i].name, url: this.additionalFilesResponse[i].path, blobId: this.additionalFilesResponse[i].blobId }

          }
        );
      }
    }

    if (this.additionalFilesResponse.length != 0)
      this.addNewElementFileAdditionalArray();
  }
  /**
   * Method used to add a new element to the file additional array
   * */
  private addNewElementFileAdditionalArray(): void
  {
    if (this.fileAdditionalArray.length + 1 != 11)
    {
      //Add a new object
      this.fileAdditionalArray.push(JSON.parse(JSON.stringify(FileAdditionalArray)));
      this.fileAdditionalArray[this.fileAdditionalArray.length - 1].Id = this.fileAdditionalArray.length - 1;
      //Change the name dynamically
      this.fileAdditionalArray[this.fileAdditionalArray.length - 1].name = "AdditionalFile" + (this.fileAdditionalArray.length - 1).toString();
      this.fileAdditionalArray[this.fileAdditionalArray.length - 1].Id = this.fileAdditionalArray.length - 1;
    }
  }
  /**
   * Method used to set a new additio
   * */
  public fileSelected(file: File, item: any): void
  {
    this.mediaDataService.saveImage(file)
      .subscribe((responseMediaService: any) =>
      {
        let body =
        {
          caseId: this.GetCaseId,
          blobId: responseMediaService.id
        };
        this.caseAdditionalDataService.saveCaseAdditional(body).subscribe((response: any) =>
        {
          this.setFile(item.Id, responseMediaService, false);
        });
      }, (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }
  /**
   * Method used to delete an image
   * */
  public deleteFile(item: any)
  {
    this.setFile(item.Id, null, true);
  }

  /**
   * Method used to set an additional file.
   * isDelete -> Add/Delete
   * */
  private setFile(id: any, fileBlobData: any, isDelete:boolean ): void
  {
    if (!isDelete)
    {
      this.fileAdditionalArray.find(x => x.Id == id).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path, blobId: fileBlobData.id } : null;
      this.fileAdditionalArray.find(x => x.Id == id).label = fileBlobData.name.slice(fileBlobData.name.indexOf("_") + 1, fileBlobData.name.length);
      //Add object
      this.addNewElementFileAdditionalArray();
    }
    else
    {
      this.deleteAdditionalFile(this.fileAdditionalArray[id].fileInfo.blobId, this.GetCaseId);
      this.fileAdditionalArray.find(x => x.Id == id).fileInfo = fileBlobData ? { name: fileBlobData.name, url: fileBlobData.path, blobId: fileBlobData.id } : null;
      //Sort and erase
      if (this.fileAdditionalArray.length != 1)
      {
        this.fileAdditionalArray.splice(id, 1);
      }
      if (this.fileAdditionalArray.length == 9)
      {
        if ((this.fileAdditionalArray.find(x => x.fileInfo == null)) === undefined)
        {
          this.addNewElementFileAdditionalArray();
        }
      }
      for (let i = 0; i < this.fileAdditionalArray.length; i++)
      {
        this.fileAdditionalArray[i].Id = i;
        this.fileAdditionalArray[i].name = "AdditionalFile" + i.toString();
      }
    }
  }
  /**
   * Method used to delete an additional file from the DB
   * */
  private deleteAdditionalFile(fileBlobId: any, fileCaseId): void
  {
    let body =
    {
      blobId: fileBlobId,
      caseId: fileCaseId
    };
    this.caseAdditionalDataService.deleteAdditionalFiles(body)
      .subscribe((response: any) =>
      {
        this.setInfoAlert("Archivo eliminado");
      }, (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }
  /**
    *Method used to retrieve the current case Id
    * (used by the client module)
    **/
  private get GetCaseId(): number
  {
    return AppClientContext.Instance.case.id;
  }
}
